<div
  *ngIf="!goodParameters"
  class="d-flex justify-content-around flex-column"
>
  <h3 class="d-flex justify-content-around">Geen (geldige) parameters gegeven.</h3>
  <div class="d-flex justify-content-around">
    <button
      class="w-25"
      (click)="returnToFreshdesk()"
    >
      Terug
    </button>
  </div>
</div>

<div
  *ngIf="error"
  class="d-flex justify-content-around flex-column"
>
  <pre class="d-flex justify-content-around">
    <h4>{{ error }}</h4>
  </pre>
  <div class="d-flex justify-content-around">
    <button
      class="w-25"
      (click)="returnToFreshdesk()"
    >
      Terug
    </button>
  </div>
</div>

<div *ngIf="goodParameters && !error">
  <h3 class="d-flex justify-content-around">Bezig met het registreren van aanpassing van een annulering...</h3>
</div>
